// ** React Imports
import { useState, useEffect, SyntheticEvent, ChangeEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    Tooltip,
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../../components/ToastProvider';

export default function Detail() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [listDetail, setListDetail] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState(false)
    const [idD, setIdD] = useState<any>(null)
    const [qty, setQty] = useState<any>(null)
    const [editQty, setEditQty] = useState<any>(null)
    const [barangId, setBarangId] = useState<any>(null)

    // ** State
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valGudang, setValGudang] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])

    const [valSubgudang, setValSubgudang] = useState<any>(null)
    const [listSubgudang, setListSubgudang] = useState<any[]>([])

    const [openDialogBaru, setOpenDialogBaru] = useState<boolean>(false)

    const handleOpenDialog = (row: any) => {
        const data = row.data

        setIdD(data.pbgr_d_id)
        setQty(data.qty_datang);
        setEditQty(null)
        setOpenDialog(true)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    useEffect(() => {
        getDetail()
        getData()
    }, [])

    const getDetail = () => {
        const url = apiUrl.apiUrl + '/purchasing/gr/detail-gr-kain'
        axios
            .get(url, {
                params: { pbgr_id: id },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]
                    const detail = response.data.detail.map((row: any, index: any) => ({
                        ...row,
                        id: index + 1
                    }));
                    setListDetail(detail)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const navigate = useNavigate();

    interface FormInputs {
        pbpr_d_id: any

        syscabang_id: any
        sysdoctag_id: any
        pbsupplier_id: any
        sysmatauang_id: any
        pbpo_id: any
        pbpo_d_id: any
        mmgudang_id: any
        mmgudang_sub_id: any
        barang: any
        qty: any
        tgl: any
        tgl_kirim: any
        transportasi: any
        harga: any
        nomor_timbang: any
        mmbarang_id: any
        nomor_sj: any
        kurir: any
        pic: any
        keterangan: any
        nama_vendor: any
        sisa_qty: any
        total: any

        qty_doc: any
        keterangan_detail: any
    }

    const defaultValues = {
        pbpr_d_id: id,
        keterangan: ''
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                let url = apiUrl.apiUrl + '/purchasing/gr/edit/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    const id = response.data.data
                                    navigate('/purchasing/purchase-order')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const getDoctag = (ids: any) => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 40
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValDoctag(element)
                        }
                    });
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getGudang = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/gudang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValGudang(element)
                        }
                    });
                    setListGudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getSubGudang = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValSubgudang(element)
                        }
                    });
                    setListSubgudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                />
            ),
        },
    ];

    const ActionButtons = ({ row }: {
        row: any;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Cetak Label">
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation(); // ? cegah rowClick
                            window.open(
                                `${apiUrl.baseUrl}/mm/batch/cetak-label-batch/${row.id_batch}`,
                                '_blank'
                            );
                        }}
                    >
                        <Icon icon={"mdi:qrcode"} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };
    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/purchasing/gr/detail/' + id
        axios
            .get(url, {
                params: { mode: 1 },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]
                    // console.log(data);
                    // console.log(response)
                    setValue('tgl', data.tgl?.substring(0, 10))
                    setValue('pbpo_id', data.pbpo_id)
                    setValue('nama_vendor', data.nama_vendor)
                    setValue('nama_vendor', data.nama_vendor)
                    setValue('barang', data.nama_barang)
                    setValue('qty', data.qty)
                    setValue('harga', data.harga)
                    setValue('total', data.total)
                    setValue('sisa_qty', data.sisa_qty)
                    setValue('pbpo_d_id', data.pbpo_d_id)
                    setValue('pbsupplier_id', data.pbsupplier_id)
                    setValue('mmbarang_id', data.mmbarang_id)
                    setValue('kurir', data.kurir)
                    setValue('transportasi', data.transportasi)
                    setValue('tgl_kirim', data.tgl_kirim?.substring(0, 10))
                    setValue('nomor_sj', data.nomor_sj)
                    setValue('keterangan', data.keterangan)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('mmgudang_id', data.mmgudang_id)
                    setValue('mmgudang_sub_id', data.mmgudang_sub_id)

                    getDoctag(data.sysdoctag_id)
                    getGudang(data.mmgudang_id)
                    getSubGudang(data.mmgudang_sub_id)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const handleSaveQty = () => {
        const qtyBaru = Number(editQty)

        if (!Number.isFinite(qtyBaru) || qtyBaru <= 0) {
            Swal.fire({ title: 'Pemberitahuan', text: 'Qty baru harus lebih besar dari 0.', icon: 'warning' })
            return
        }

        setOpenDialog(false)

        const data = {
            pbgr_id: id,
            pbgr_d_id: idD,
            qty: qty,
            qty_baru: editQty,
        }

        const url = apiUrl.apiUrl + '/purchasing/gr/edit-qty'
        axios
            .post(url, data, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: true,
                        willClose: () => {
                            getDetail()
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
    }

    const customRender = [
        {
            key: "qty_datang",
            renderCell: (row: any) => (
                <Typography variant='body2' sx={{ fontWeight: 400 }}>
                    {row.value}
                    <IconButton color='primary' onClick={() => handleOpenDialog(row)}>
                        <Icon icon='mdi:pencil' fontSize={20} />
                    </IconButton>
                </Typography>
            ),
        },
    ];

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_id', newValue?.id)
        setValGudang(newValue)
    }

    const handleChangeAutocompleteSubgudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_sub_id', newValue?.id)
        setValSubgudang(newValue)
    }


    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Good Receipt Kain
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 3 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tanggal'
                                                type='date'
                                                error={Boolean(errors.tgl)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='barang'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                InputProps={{ readOnly: true }}
                                                label='Nama Barang'
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_vendor'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                InputProps={{ readOnly: true }}
                                                label='Vendor'
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nomor_sj'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Surat Jalan'
                                                error={Boolean(errors.nomor_sj)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nomor_sj && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_kirim'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tanggal Kirim'
                                                type='date'
                                                error={Boolean(errors.tgl_kirim)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tgl_kirim && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='transportasi'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Transportasi'
                                                error={Boolean(errors.transportasi)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.transportasi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kurir'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Kurir'
                                                error={Boolean(errors.kurir)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.kurir && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmgudang_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valGudang}
                                                options={listGudang}
                                                id='mmgudang_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteGudang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Gudang'
                                                        error={Boolean(errors.mmgudang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmgudang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmgudang_sub_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valSubgudang}
                                                options={listSubgudang}
                                                id='mmgudang_sub_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteSubgudang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Sub Gudang'
                                                        error={Boolean(errors.mmgudang_sub_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmgudang_sub_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                multiline
                                                rows={3}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        mb: 1
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="success"
                                        startIcon={<Icon icon="mdi:plus" />}
                                        onClick={() => {
                                            setValue('qty_doc', null);
                                            setOpenDialogBaru(true);
                                        }}
                                    >
                                        Tambah Batch Baru
                                    </Button>
                                </Box>
                                <MsiDatagrid array={listDetail} actions={actionData} hiddenColumns={[
                                    'id', 'deleted_at', 'konversi', 'tgl_kebutuhan', 'pbgr_d_id', 'pbgr_id', 'mmbarang_id', 'created_at', 'created_by',
                                    'updated_at', 'updated_by', 'valas', 'keterangan', 'kode_barang', 'jenis_barang'
                                ]}
                                    customRender={customRender}
                                />
                            </Grid>

                        </Grid>
                    </form>
                </div>
            </Grid>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogBaru}
                onClose={() => setOpenDialogBaru(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='h6' sx={{ fontWeight: 500, color: '#212121' }}>
                        Tambah Batch Kain
                    </Typography>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={3}>
                        {/* QTY */}
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name="qty_doc"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <TextField
                                            fullWidth
                                            label="Quantity"
                                            type="number"
                                            {...field}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                                {errors.qty_doc && (
                                    <FormHelperText sx={{ color: "error.main" }}>
                                        Form ini tidak boleh kosong.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        {/* KETERANGAN */}
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name="keterangan_detail"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            fullWidth
                                            label="Keterangan"
                                            {...field}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions className='dialog-actions-dense'>
                    <Button
                        variant="contained"
                        onClick={() => {
                            const data = getValues(); // <-- Ambil semua input dari RHF
                            if (!data.qty_doc || data.qty_doc === 0) {
                                showToast('Quantity wajib diisi', 'error');
                                return;
                            }
                            setOpenDialogBaru(false);

                            let url = apiUrl.apiUrl + '/purchasing/gr/save-detail/' + id;

                            axios.post(url, data, {
                                headers: { Authorization: `Bearer ${token}` }
                            })
                                .then(response => {
                                    if (response.data.success) {
                                        showToast(response.data.message, 'success');

                                        window.open(
                                            `${apiUrl.baseUrl}/mm/batch/cetak-label-batch/${response.data.batch_id}`,
                                            '_blank'
                                        );

                                        getDetail();
                                    } else {
                                        showToast(response.data.message, 'error');
                                    }
                                })
                                .catch(error => {
                                    showToast(error.message, 'error');
                                });
                        }}
                    >
                        Simpan
                    </Button>

                    <Button onClick={() => setOpenDialogBaru(false)}>Batal</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth={'xs'}
                fullWidth={true}
                open={openDialog}
                onClose={handleCloseDialog}
            >
                <DialogTitle>
                    <Typography variant='body1' sx={{ fontWeight: 500, my: 1.5, color: '#212121' }}>
                        Edit Qty Barang
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ pt: 1 }}>
                    <Typography variant='body1' sx={{ fontWeight: 500, my: 1.5, color: '#212121' }}>
                        Qty Lama : {qty}
                    </Typography>
                    <TextField
                        sx={{ my: 2 }}
                        fullWidth
                        label='Qty Baru'
                        type='number'
                        value={editQty}
                        autoFocus
                        onChange={e => setEditQty(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        onKeyDown={(e) => {
                            // cadangan: jika pengguna tekan Enter di field, submit juga
                            if (e.key === 'Enter') {
                                e.preventDefault()
                                handleSaveQty()
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color='inherit'>
                        Batal
                    </Button>
                    <Button onClick={handleSaveQty} variant='contained' color='primary'>
                        Simpan
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}